import { render } from "./confirm-dialog.vue?vue&type=template&id=f25171ec&scoped=true&lang=true"
import script from "./confirm-dialog.vue?vue&type=script&lang=js"
export * from "./confirm-dialog.vue?vue&type=script&lang=js"

import "./confirm-dialog.vue?vue&type=style&index=0&id=f25171ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25171ec"]])

export default __exports__